import { CheckoutState } from '../../state';
import { hasOptionalQuestions } from './hasOptionalQuestions';

export const isOrderFormSplittedInTwoPages = (state: CheckoutState): boolean =>
    hasOptionalQuestions(state);
